var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "url(#paint0_linear_192_1096)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.11429 12.0716L7.93772 11.3206C8.16446 11.1138 8.53439 11.1138 8.76114 11.3206L11.0753 13.4312C11.0802 13.4357 11.087 13.4379 11.0944 13.4379C11.1017 13.4374 11.1079 13.4346 11.1122 13.4295L16.5191 7.14942C16.7256 6.90955 17.1035 6.87481 17.3573 7.0732L17.8519 7.46046C18.0848 7.64315 18.1235 7.95868 17.9386 8.18228L11.7937 15.6035C11.6112 15.8244 11.3599 15.9499 11.0576 15.9695C10.7552 15.9891 10.4867 15.8978 10.2722 15.7022C9.21961 14.7422 8.16696 13.7821 7.1144 12.8222C6.88765 12.6159 6.88765 12.2785 7.1144 12.0717L7.11429 12.0716Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_192_1096",
    x1: 21.9551,
    y1: 18.75,
    x2: 8.49395,
    y2: -4.09301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E47C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495859,
    stopColor: "#46A37E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009064"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatIcon);
export default __webpack_public_path__ + "static/media/format-icon.fa09041bcad8e18947a307dbb98e9225.svg";
export { ForwardRef as ReactComponent };